import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, Injector, ChangeDetectionStrategy } from '@angular/core';
import { Mtrpi01Component } from './mtrpi01Pkg.component';
//import { Mtrpi01DetailComponent } from './mtrpi01-detailPkg.component';
import { MaterialModule } from 'jk-service';//###
import { JackBaseComponentModule } from 'jk-service'; //###
import { JkBillFormComponent } from 'jk-advcom'; // ###

@Component({
  selector: 'app-mtrpi01-bill',
  standalone: true,
  imports: [CommonModule,
    MaterialModule,
    JackBaseComponentModule,
    Mtrpi01Component,
    //Mtrpi01DetailComponent, // ###
  ],
  templateUrl: './mtrpi01BillPkg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Mtrpi01BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = ' mtrpi01'; //###
  override masterPage!: Mtrpi01Component;
  //override detailPage!:  Mtrpi01DetailComponent; ###
  constructor() {
    super();
    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}
